import { combineReducers } from "redux";
import authReducer from "./authReducer";

// Combinar los reducer de la aplicación
export default combineReducers({
    authReducer,
});
